import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ShowcasePageBlockCarouselSlideDto } from './ShowcasePageBlockCarouselSlideDto'
/**
* Class ShowcasePageBlockCarouselDto
*  Опубликованная карусель витрины.
*/
export class ShowcasePageBlockCarouselDto extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'Carousel' })
  readonly type: string = 'Carousel'


/**
  * key
  * Ключ слота; уникален в рамках канала среди неудалённых.<br>Задаётся оператором; шаблон витрины запрашивает блок по этому ключу.<br>
  */
  @ActiveField('')
  key: string = ''


/**
  * @property slides
  * Слайды карусели.  */
  @ActiveField({
    factory: [ShowcasePageBlockCarouselSlideDto, () => undefined]
  })
  slides?: Array<ShowcasePageBlockCarouselSlideDto>
}
